import { render, staticRenderFns } from "./CharacteristicRegister.vue?vue&type=template&id=191844d6"
import script from "./CharacteristicRegister.vue?vue&type=script&lang=js"
export * from "./CharacteristicRegister.vue?vue&type=script&lang=js"
import style0 from "./CharacteristicRegister.vue?vue&type=style&index=0&id=191844d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports